export default __webpack_public_path__ + "img/non-persenter-bae98193.png";